import React from "react";
import { Empty } from "antd";
import style from "./index.module.scss";
import classNames from "classnames";

const imageMap = {
    default: require("./img/bg.png"),
    todo: require("./img/bg-todo.png")
};

interface CustomEmptyProps {
    image: keyof typeof imageMap;
    description: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export default function CustomEmpty(props: CustomEmptyProps) {
    const image = imageMap[props.image];

    return (
        <Empty
            {...props}
            image={image}
            className={classNames(style.root, props.className)}
            style={props.style}
        />
    );
}

CustomEmpty.defaultProps = {
    image: "default",
    description: "无内容"
};
